import { TrexLogo } from "./TrexLogo";

interface Props {
  /** "assistant" shows the branded dino; "user" shows the person's initials. */
  variant: "assistant" | "user";
  /** Initials to display for the user variant. */
  initials?: string;
}

/**
 * Small round chat avatar — the T-Rex mascot for the assistant, initials for
 * the user — so the conversation reads like a familiar messaging app.
 */
export const ChatAvatar = ({ variant, initials }: Props) =>
  variant === "assistant" ? (
    <div
      aria-hidden
      className="flex h-7 w-7 shrink-0 items-center justify-center overflow-hidden rounded-full bg-white shadow-sm ring-1 ring-black/5"
    >
      <TrexLogo className="h-full w-full" />
    </div>
  ) : (
    <div
      aria-hidden
      className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-slate-200 text-2xs font-bold uppercase text-slate-600 ring-1 ring-black/5"
    >
      {initials || "?"}
    </div>
  );
